{
  "auth": {
    "mfa": {
      "title": "Vérification en deux étapes",
      "description": "Saisissez le code à six chiffres de votre application d'authentification.",
      "code": "Code de vérification",
      "submit": "Vérifier",
      "cancel": "Retour à la connexion",
      "invalid": "Saisissez un code valide à six chiffres.",
      "error": "Le code de vérification n'a pas pu être accepté.",
      "unsupported": "Ce compte utilise une méthode d'AMF non prise en charge.",
      "revert": {
        "title": "Supprimer la vérification en deux étapes ?",
        "description": "Cela supprimera {{factor}} de votre compte. Continuez seulement si vous avez demandé ce changement.",
        "confirmation": "Je veux supprimer cet authentificateur.",
        "submit": "Supprimer l'authentificateur",
        "success": {
          "title": "Authentificateur supprimé",
          "description": "L'authentificateur a été supprimé de votre compte.",
          "signIn": "Continuer vers la connexion"
        },
        "error": {
          "title": "Lien expiré ou déjà utilisé",
          "description": "L'authentificateur n'a pas été supprimé. Vous devrez toujours fournir un code de celui-ci pour vous connecter — contactez le soutien si vous n'y avez plus accès.",
          "signIn": "Retour à la connexion"
        }
      }
    }
  },
  "signin": {
    "title": "Connectez-vous à votre compte",
    "email": {
      "required": "L'adresse courriel est requise.",
      "invalid": "Veuillez entrer une adresse courriel valide.",
      "title": "Courriel"
    },
    "password": {
      "required": "Le mot de passe est requis.",
      "minLength": "Le mot de passe doit contenir au moins 6 caractères.",
      "title": "Mot de passe",
      "forgot": "Mot de passe oublié ?",
      "aria": "Afficher/masquer le mot de passe"
    },
    "submit": "Se connecter",
    "info": {
      "title": "Vous n'avez pas encore de compte ?",
      "learn": "En savoir plus"
    }
  },
  "forgotpassword": {
    "title": "Réinitialiser le mot de passe",
    "description": "Entrez votre adresse courriel pour réinitialiser votre mot de passe",
    "email": {
      "title": "Adresse courriel",
      "required": "L'adresse courriel est requise",
      "invalid": "Entrez une adresse courriel valide"
    },
    "submit": "Réinitialiser le mot de passe",
    "backtosignin": "Retour à la connexion",
    "success": "Courriel de réinitialisation envoyé. Vérifiez votre boîte de réception."
  },
  "passwordreset": {
    "title": "Réinitialisation du mot de passe",
    "description": "Veuillez entrer votre nouveau mot de passe.",
    "email": {
      "title": "Courriel"
    },
    "password": {
      "title": "Nouveau mot de passe",
      "required": "Le mot de passe est requis",
      "complexity": "Le mot de passe n'est pas conforme.",
      "repeat": {
        "title": "Répéter le nouveau mot de passe",
        "required": "Veuillez confirmer votre mot de passe",
        "match": "Les mots de passe doivent correspondre."
      }
    },
    "submit": "Réinitialiser le mot de passe",
    "continue": "Continuer",
    "backtosignin": "Retour à la connexion",
    "success": "Votre mot de passe a été réinitialisé avec succès.",
    "invalid": {
      "password": "Votre mot de passe est invalide ou le code de réinitialisation du mot de passe a expiré.",
      "code": "Le code de réinitialisation du mot de passe est invalide ou a expiré."
    }
  },
  "verifyemail": {
    "title": "Vérification de l'email",
    "description": "Veuillez entrer votre nouveau mot de passe.",
    "subdescription": "Il doit comporter au moins 8 caractères, contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.",
    "password": {
      "title": "Nouveau mot de passe",
      "required": "Le mot de passe est requis",
      "complexity": "Le mot de passe n'est pas conforme.",
      "repeat": {
        "title": "Répéter le nouveau mot de passe",
        "required": "Veuillez confirmer votre mot de passe",
        "match": "Les mots de passe doivent correspondre."
      }
    },
    "submit": "Réinitialiser le mot de passe",
    "continue": "Continuer",
    "backtosignin": "Retour à la connexion",
    "success": "Votre email a été vérifié avec succès.",
    "successreset": "Votre mot de passe a été défini avec succès.",
    "invalid": {
      "password": "Votre mot de passe est invalide.",
      "code": "Le code de réinitialisation du mot de passe est invalide ou a expiré."
    },
    "unknownerror": "Une erreur inconnue s'est produite lors de la vérification de l'email."
  },
  "autherror": {
    "user": {
      "notfound": "Aucun compte trouvé avec cette adresse courriel.",
      "disabled": "Ce compte a été désactivé."
    },
    "invalid": {
      "password": "Courriel ou mot de passe invalide.",
      "credential": "Courriel ou mot de passe invalide.",
      "email": "Adresse courriel invalide.",
      "actioncode": "Vérification d'adresse courriel échouée",
      "reqtype": "Vérification d'adresse courriel échouée"
    },
    "request": {
      "toomany": "Trop de tentatives. Veuillez réessayer plus tard."
    },
    "expired": {
      "oobcode": "Lien expiré"
    },
    "default": "Une erreur est survenue. Veuillez réessayer."
  },
  "lang": "EN",
  "redirect": {
    "title": "Redirection...",
    "subtitle": "Connecté en tant que"
  }
}
